import { Bookmark, LastSearchBookmarkBody, PostBookmark } from '../models/bookmark';
import { BookmarkService } from './bookmark.service';

export class LastSearchBookmarkService extends BookmarkService<
  Bookmark<LastSearchBookmarkBody>,
  LastSearchBookmarkBody
> {
  search(text: string): void {
    this.create({
      body: {
        text: text,
      },
    });
  }
  override async delete(key: string): Promise<void> {
    await super.delete(key);
    this.reload();
  }

  async deleteAll() {
    const all = this.all();
    await Promise.all(all?.map((e) => this.delete(e.key)) || []);
    this.reload();
  }

  override async create(bookmark: PostBookmark<LastSearchBookmarkBody>): Promise<void> {
    await super.create(bookmark);
    const all = this.all();

    // Track if any duplicate was deleted
    let duplicateDeleted = false;

    // Use Promise.all to wait for all delete operations
    const deletePromises =
      all
        ?.filter((e) => e.body.text === bookmark.body.text && e.key !== bookmark.key)
        .map((e) => this.delete(e.key)) || [];

    if (deletePromises.length > 0) {
      await Promise.all(deletePromises);
      duplicateDeleted = true;
    }

    // Only delete the oldest entry if we're still over the limit and no duplicates were removed
    if ((all?.length ?? 0) > 5 && !duplicateDeleted) {
      const key = all?.[all.length - 1]?.key;
      if (key) {
        await this.delete(key);
      }
    }

    this.reload();
  }
}

/* EXAMPLE USAGE */
/* providers: [
  { provide: LastSearchBookmarkRepository, useFactory: () => new LastSearchBookmarkRepository('product') }
]
*/
